module.exports = __webpack_public_path__ + "img/calendar-2_fill.2eb6a464.svg";